import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ContactCardsAPI from '../../api/wgpt/contactCards';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  get($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, contactId) => {
    commit(types.SET_WGPT_CONTACT_CARD_UI_FLAG, { isFetching: true });
    try {
      const contactCardsAPI = new ContactCardsAPI(contactId);
      const { data } = await contactCardsAPI.get();
      commit(types.SET_WGPT_CONTACT_CARDS, data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_CONTACT_CARD_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_WGPT_CONTACT_CARD_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_WGPT_CONTACT_CARDS]: MutationHelpers.set,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
